import { createRouter, createWebHistory } from "vue-router";
import Contact from "../views/ContactUs.vue";

const routes = [
  {
    path: "/",
    name: "contact-us",
    component: Contact,
    meta: {
      title: "Contact Us | Quizzr",
    },
  },
  {
    path: "/pricing",
    name: "pricing",
    component: () => import("../views/PricingDetails.vue"),
    meta: {
      title: "Pricing details | Quizzr",
    },
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("../views/PrivacyPage.vue"),
    meta: {
      title: "Privacy policy | Quizzr",
    },
  },
  {
    path: "/terms",
    name: "terms",
    component: () => import("../views/TermsPage.vue"),
    meta: {
      title: "Terms and conditions | Quizzr",
    },
  },
  {
    path: "/refund",
    name: "refund",
    component: () => import("../views/RefundPage.vue"),
    meta: {
      title: "Cancellation/Refund policy | Quizzr",
    },
  },
  {
    path: "/aboutus",
    name: "about-us",
    component: () => import("../views/AboutUs.vue"),
    meta: {
      title: "About us | Quizzr",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || "Quizzr";
  next();
});

export default router;
